import { Link } from "react-router-dom";

export const Logo = ({ dark = false }) => {
  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className="flex items-center gap-2.5 group"
    >
      <svg
        width="34"
        height="34"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 transition-transform duration-500 group-hover:rotate-[8deg]"
      >
        <path
          d="M18 6C18 6 13 13 13 19C13 22.3137 15.2386 25 18 25C20.7614 25 23 22.3137 23 19C23 13 18 6 18 6Z"
          stroke="#6B8E78"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 25C14 25 8 20 8 16C8 13.5 10 12 12 12C14.5 12 16.5 15 18 18"
          stroke="#C07D60"
          strokeWidth="1.3"
          strokeLinecap="round"
        />
        <path
          d="M18 25C22 25 28 20 28 16C28 13.5 26 12 24 12C21.5 12 19.5 15 18 18"
          stroke="#C07D60"
          strokeWidth="1.3"
          strokeLinecap="round"
        />
      </svg>
      <span
        className={`font-serif text-xl sm:text-2xl leading-none tracking-tight ${
          dark ? "text-spa-cream" : "text-spa-slate"
        }`}
      >
        Blossom<span className="text-spa-terracotta italic"> Spa</span>
      </span>
    </Link>
  );
};
